import classNames from 'classnames'
import { useMemo, useState } from 'react'
import { useSlate } from 'slate-react'

import { IPopupMethods } from 'core-components/library/popup'
import { insertTable } from 'core-components/library/richTextEditor/helpers/slateHelper'

import styles from './TableInsertPopup.module.scss'

const MAX_TABLE_SIZE = 10

export const TableInsertPopup = ({ close }: Pick<IPopupMethods, 'close'>) => {
  const editor = useSlate()
  const [tableSelection, setTableSelection] = useState({
    row: 0,
    column: 0,
  })

  const tableInput = useMemo(() => {
    return Array.from({ length: MAX_TABLE_SIZE }, (obj, row) =>
      Array.from({ length: MAX_TABLE_SIZE }, (v, col) => ({
        selected: row + 1 <= tableSelection.row && col + 1 <= tableSelection.column,
        column: col,
      }))
    )
  }, [tableSelection])

  const addTable = () => {
    insertTable(editor, tableSelection.column, tableSelection.row)
    close()
  }

  return (
    <div className={styles.root}>
      <div className={styles.table__input}>
        {tableInput.map((grp, row) =>
          grp.map(({ column, selected }, index) => (
            <div
              key={`${row}${index}`}
              onClick={() => addTable()}
              onMouseOver={() => setTableSelection({ row: row + 1, column: column + 1 })}
              className={classNames(styles.table__cell, selected && styles.table__cell__selected)}
            ></div>
          ))
        )}
      </div>
      <div>{`${tableSelection.column}x${tableSelection.row}`}</div>
    </div>
  )
}
